/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeCircleIcon16Light } from './ShapeCircleIcon16Light';
import { ShapeCircleIcon16Regular } from './ShapeCircleIcon16Regular';
import { ShapeCircleIcon16Solid } from './ShapeCircleIcon16Solid';
import { ShapeCircleIcon20Light } from './ShapeCircleIcon20Light';
import { ShapeCircleIcon20Regular } from './ShapeCircleIcon20Regular';
import { ShapeCircleIcon20Solid } from './ShapeCircleIcon20Solid';
import { ShapeCircleIcon24Regular } from './ShapeCircleIcon24Regular';
import { ShapeCircleIcon24Solid } from './ShapeCircleIcon24Solid';
import { ShapeCircleIcon32Regular } from './ShapeCircleIcon32Regular';
import { ShapeCircleIcon64Regular } from './ShapeCircleIcon64Regular';
var sizes = {
    16: {
        light: ShapeCircleIcon16Light,
        regular: ShapeCircleIcon16Regular,
        solid: ShapeCircleIcon16Solid,
    },
    20: {
        light: ShapeCircleIcon20Light,
        regular: ShapeCircleIcon20Regular,
        solid: ShapeCircleIcon20Solid,
    },
    24: {
        regular: ShapeCircleIcon24Regular,
        solid: ShapeCircleIcon24Solid,
    },
    32: {
        regular: ShapeCircleIcon32Regular,
    },
    64: {
        regular: ShapeCircleIcon64Regular,
    },
};
export var ShapeCircleIcon = forwardRef('ShapeCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
